var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ur-sel-modal-warn"},[_c('v-icon',{attrs:{"size":"70","color":"orange"}},[_vm._v("icon-chat")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }